export const TASK_ACTIVITIES_ACTIONS = {
  TASK_ACTIVITIES_PAGE_LOADED: 'TASK_ACTIVITIES_PAGE_LOADED',
  TASK_ACTIVITIES_PLANNED_TOOLSTRING_LOADED:
    'TASK_ACTIVITIES_PLANNED_TOOLSTRING_LOADED',
  TASK_ACTIVITIES_RECEIVE_PLANNED_TOOLSTRING:
    'TASK_ACTIVITIES_RECEIVE_PLANNED_TOOLSTRING',
  TASK_ACTIVITIES_RECEIVE_NO_TOOLSTRING:
    'TASK_ACTIVITIES_RECEIVE_NO_TOOLSTRING',
};
